module.exports = __webpack_public_path__ + "img/location.3842e97b.svg";